<template>
    <div class="card">
        <header class="card-header">
            <p class="card-header-title">
                <button
                    class="rj-card-title-btn"
                    @click="$emit('load_job_description', job, jobMatchID, isRelevant)">
                    {{ job.jobtitle }}
                </button>
            </p>
            <span v-if="job.matched" class="tag is-success is-rounded ml-2">✓ Matched</span>
        </header>
        <div class="card-content">
            <div class="content">
                <p v-if="job_score">
                    <span class="tag is-danger is-medium">
                        <b><u>User Match Score</u></b> - {{ job_score }}
                    </span>
                </p>
                <p class="is-6 has-text-weight-semibold mb-1">
                    {{ job.organization }}
                </p>
                <time>{{ job.post_date }}</time>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
defineProps<{
  job: any
  job_score?: number
  jobMatchID?: string
  isRelevant?: boolean | null
}>()

defineEmits<{
  load_job_description: [job: any, jobMatchID?: string, isRelevant?: boolean | null]
}>()
</script>
